import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/user_location/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/user_location/insert', data);
  },
  async update(data) {
    return await http.post('/api/user_location/update', data);
  },
  async delete(data) {
    return await http.post('/api/user_location/delete', data);
  },
  async getLocation(id) {
    return await http.get(`/api/user_location/get-location/${id}`);
  },
  async getNearUsers(id) {
    return await http.get(`/api/user_location/get-near-users/${id}`);
  }
};